import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackViewContent } from '../utils/metaPixel';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    trackViewContent();
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <AnimatePresence data-id="element-232">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-cream border-t-2 border-gold/30 shadow-[0_-4px_10px_rgba(0,0,0,0.1)] p-4" data-id="element-233">
          <div className="flex items-center justify-between gap-4 max-w-md mx-auto" data-id="element-234">
            <div className="flex flex-col" data-id="element-235">
              <span className="text-xs text-gray-500 uppercase tracking-wider font-bold" data-id="element-236">
                Oferta Especial
              </span>
              <span className="text-burgundy font-bold font-serif text-xl" data-id="element-237">
                $9.95
              </span>
            </div>
            <button onClick={handleClick} className="bg-burgundy text-cream font-bold py-3 px-6 rounded-none border-2 border-burgundy hover:bg-cream hover:text-burgundy transition-colors duration-300 uppercase tracking-wider text-[13px] shadow-md flex items-center gap-2 flex-grow justify-center" data-id="element-238">
              Comprar Ahora
              <ArrowRightIcon className="w-4 h-4" data-id="element-239" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}